import { OnInit, Component, OnDestroy, Input } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { Subscription } from 'rxjs';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';

@Component({
    selector: 'app-transferir-turno-UAC',
    templateUrl: './transferir-turno-UAC.component.html',
    styleUrls: ['./atender-ciudadano-UAC.component.scss']
})

export class TransferirTurnoUACComponent implements OnInit, OnDestroy {
    public modalOptions: ConfirmationModalOptions;
    private subscription: Subscription[];
    @Input() numeroVentanilla: any;
    @Input() listaTramites: any[];
    @Input() tramiteActual: any;
    @Input() turno: any;

    public tramiteAtender: any;

    constructor(private alertService: AlertService, private activeModal: NgbActiveModal
        , private urlService: UrlService, private global: GlobalService
        , private spiner: NgxSpinnerService) {

        this.subscription = [];
        this.modalOptions = new ConfirmationModalOptions('Confirmaciòn', '¿Está seguro de transferir el turno?', 'SI', 'NO', 'fas fa-exchange-alt', true, null, 'Transferir Turno', null, 'btn btn-secondary');
        this.listaTramites = [];
        this.tramiteAtender = null;
    }


    ngOnInit() {

    }
    /**
     * 
     */
    close() {
        this.activeModal.close();
    }


    /**
     * metodo que realiza la petición de actualización del tràmite
     * @author fromero
     * @param event 
     */
    actualizarTramiteTurno(event) {
        if (event[0] && this.tramiteAtender != null) {
            if (this.tramiteActual.idTramite == this.tramiteAtender.idTramite) {
                this.alertService.generateAlertError('El turno no se puede transferir porque está seleccionando el mismo trámite que está atendiendo en la ventanilla', '');
            } else {
                this.spiner.show();
                const serviceProvider = 'cambiarTramiteTurnoUac';
                var queryParams: Array<[string, string]> = new Array<[string, string]>();

                this.turno.idTramite = this.tramiteAtender.idTramite;
                const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
                const sucripcion = this.global.postGenerico(url, this.turno).subscribe(
                    data => {
                        this.alertService.generateAlertSuccess(data.mensaje, '');
                        this.activeModal.close(true);
                        this.spiner.hide();
                    }, err => {
                        this.cathException(err.error.message);
                    }
                );
                this.subscription.push(sucripcion);
            }

        }
    }

    /**
     * @author fromero
     * activa el boton de cambio de estado cuando el motivo es diligenciado
     */
    setMotivo() {
        this.modalOptions.disabled = false;
    }

    /**
    * 
    * @param error 
    */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spiner.hide();
    }

    /**
     * destruye las subscripciones del componente 
     * 
     */
    ngOnDestroy() {
        this.subscription.forEach(el => {
            el.unsubscribe();
        })
    }

    /**
     * activa el boton de confirmaciòn
     */
    validarCambioTramite() {
        this.modalOptions.disabled = false;
    }

}